import React from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import ProblemeQualiteProduitDialogContent from './ProblemeQualiteProduitDialogContent';
import withLoader from 'components/Shared/withLoader';
import { fetchInfosActionMagasin } from 'store/reclamation/detailsActions';
import { sansDepotMagasin } from 'utils/depotHelper';

const ProblemeQualiteProduitDialogContentWithLoader = withLoader(ProblemeQualiteProduitDialogContent);

class ProblemeQualiteProduitDialogContentContainer extends React.Component {
    
    async componentDidMount() {
        await this.props.fetchInfosActionMagasin(this.props.reclamationId);
    }

    render() {
        const { onChange, action, isLoading, articles, piece, depotDepart, reclamationMagasin } = this.props;

        let codeDepot = reclamationMagasin ? reclamationMagasin.code : '';

        if (codeDepot === '') {
            let utilisateur = JSON.parse(localStorage.getItem('utilisateur'));

            if (sansDepotMagasin(utilisateur)) {
                if (utilisateur.depots && utilisateur.depots.length === 1) {
                    codeDepot = utilisateur.depots[0].code;
                }
            }
            else {
                codeDepot = utilisateur.depot.code;
            }
        }


        return (
        <ProblemeQualiteProduitDialogContentWithLoader
                isLoading={isLoading}
                onChange={onChange}
                action={action}
                codeDepot={codeDepot}
                articles={articles}
                piece={piece}
                depotDepart={depotDepart}
        />);
    }
}

ProblemeQualiteProduitDialogContentContainer.propTypes = {
    onChange: PropTypes.func.isRequired,
    action: PropTypes.object.isRequired
};

const mapStateToProps = (state, props) => ({
    articles: state.reclamation.details.infosActionMagasin.articles,
    piece: state.reclamation.details.infosActionMagasin.piece,
    depotDepart: state.reclamation.details.infosActionMagasin.depotDepart,
    reclamationMagasin: state.reclamation.details.infosActionMagasin.reclamationMagasin,
    isLoading: state.reclamation.details.infosActionMagasin.isLoading
});

const mapDispatchToProps = dispatch => ({
    fetchInfosActionMagasin: (id) => dispatch(fetchInfosActionMagasin(id, true))
});

export default connect(mapStateToProps, mapDispatchToProps)(ProblemeQualiteProduitDialogContentContainer);